<script setup lang="ts">
import { Checkbox } from '@/components/ui/checkbox';

withDefaults(defineProps<{
    modelValue?: boolean | 'indeterminate';
    label: string;
    disabled?: boolean;
}>(), {
    modelValue: false,
    disabled: false,
});

const emit = defineEmits<{
    (event: 'toggle'): void;
}>();
</script>

<template>
    <label
        class="inline-flex min-h-8 cursor-pointer items-center gap-2 rounded-md px-2 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
        :class="disabled ? 'pointer-events-none opacity-50' : ''"
    >
        <Checkbox
            :model-value="modelValue"
            :disabled="disabled"
            :aria-label="label"
            @update:model-value="emit('toggle')"
        />
        <span>{{ label }}</span>
    </label>
</template>
